import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { HelmetProvider } from "react-helmet-async";
import "./App.css";

import Layout from "./components/Layout";
import GAPageView from "./components/GAPageView";
import ScrollToTop from "./components/ScrollToTop";
import ProtectedRoute from "./components/ProtectedRoute";
import { AuthProvider } from "./context/AuthContext";

import Home from "./pages/Home";
import Academy from "./pages/Academy";
import PerformanceLab from "./pages/PerformanceLab";
import ContentAgency from "./pages/ContentAgency";
import About from "./pages/About";
import PrincipalsCorner from "./pages/PrincipalsCorner";
import Partnership from "./pages/Partnership";
import Contact from "./pages/Contact";
import PerforangeOS from "./pages/PerforangeOS";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";

import AdminLogin from "./pages/admin/AdminLogin";
import AdminLayout from "./pages/admin/AdminLayout";
import AdminBlogList from "./pages/admin/AdminBlogList";
import AdminBlogEdit from "./pages/admin/AdminBlogEdit";
import AdminLeads from "./pages/admin/AdminLeads";

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <AuthProvider>
          <ScrollToTop />
          <GAPageView />
          <Routes>
            {/* Public site */}
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/academy" element={<Academy />} />
              <Route path="/performance-lab" element={<PerformanceLab />} />
              <Route path="/content-agency" element={<ContentAgency />} />
              <Route path="/perforange-os" element={<PerforangeOS />} />
              <Route path="/about" element={<About />} />
              <Route path="/principals-corner" element={<PrincipalsCorner />} />
              <Route path="/pricing" element={<Partnership />} />
              <Route path="/partnership" element={<Partnership />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:slug" element={<BlogPost />} />
            </Route>

            {/* Admin */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<AdminBlogList />} />
              <Route path="blog" element={<AdminBlogList />} />
              <Route path="blog/new" element={<AdminBlogEdit />} />
              <Route path="blog/edit/:slug" element={<AdminBlogEdit />} />
              <Route path="leads" element={<AdminLeads />} />
            </Route>
          </Routes>
          </AuthProvider>
        </BrowserRouter>
        <Toaster
          theme="dark"
          position="top-right"
          toastOptions={{
            style: {
              background: "#121216",
              border: "1px solid rgba(255,140,0,0.3)",
              color: "#F8F8F9",
            },
          }}
        />
      </div>
    </HelmetProvider>
  );
}

export default App;
